import React from "react";
import slugify from "react-slugify";
import { isMobile } from "react-device-detect";

import { H1 } from "./headings";
import { WEB_URL } from "../api/URLs";
import { S3_BUCKET } from "../constants";
import ImageLoaderGif from "../assets/images/loader.gif"
import DefaultCoverImage from "../assets/images/cover.jpg"
import { donationConstants } from "../store/actionTypes";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Span, MuiAvatar as Avatar, ProgressBar, MixPanelTrackedLink } from ".";
import { currencyNeedsSpace } from "../helpers";

export function PageListCard({ page }) {
    const coverImage = page.cover_image ?
        S3_BUCKET + "medium/" + page.cover_image :
        DefaultCoverImage

    const linkToPage = WEB_URL.FUNDRAISER_DETAILS(page.event_id, slugify(page.page_title) )
   
    let fundRaisedPercentage = (page.total_fund_raised / page.fundraising_goal) * 100;
    fundRaisedPercentage = Math.round(fundRaisedPercentage);

    return <div onClick={() => window.location.href = linkToPage  } key={page.id} className="box"
        impact={page.impact}
        created_no_days_ago={page.created_days_ago}
        popularity_rating={page.total_impact}
        created_at_date={page.created_at}  
    >

        <div className="card1">
            <div className="card-top-por">
                <MixPanelTrackedLink sx={{width: '100%'}} type="link" label="none" context={`Cover image of ${page.page_title} on fundraiser listing`} href={linkToPage}>
                    <div className="card-main-img" style={{ width: '100%' }}>
                        <div className="bg-picture"
                            style={{
                                backgroundSize: '50px 50px',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundImage: `url(${ImageLoaderGif})`
                            }}
                            alt="Responsive image img-fluid">
                            <LazyLoadImage
                                src={coverImage} // use normal <img> attributes as props
                                effect="blur"
                                className="bg-picture-img"
                                style={{ width: '100%' }}
                                threshold='200'
                                onError={(e) => { e.target.onerror = null; e.target.src = S3_BUCKET + 'medium/fundraiser-pages/September2020/fc-128-1599224373.jpg' }}
                            />
                        </div>
                    </div>
                </MixPanelTrackedLink>
            </div>
            <div className="card-content">
                <div className="cardmeta">
                    <H1
                        title={page.page_title}
                        impact={page.impact}
                        created_no_days_ago={page.created_days_ago}
                        popularity_rating={page.total_impact}
                        created_at_date={page.created_at}
                        content={<MixPanelTrackedLink color="inherit" underline="none" type="link" label={`${page.page_title}`} context={`Card of ${page.page_title} on fundraiser listing`} href={linkToPage}>{page.page_title}</MixPanelTrackedLink>} />


                    <ProgressBar
                        fontSize={isMobile ? '11px' : '14px'}
                        percentage={fundRaisedPercentage > 100 ? 100 : fundRaisedPercentage}
                        displayTextInOneLine={isMobile}
                        text={`${(fundRaisedPercentage > 100 ? 100 : fundRaisedPercentage)}% raised of ${page.symbol_left} ${(donationConstants.AMOUNT_FORMAT.includes(page.currency_code) ? page.fundraising_goal_human_readable.toLocaleString('de-DE') : page.fundraising_goal_human_readable.toLocaleString())}`}
                        minValueText={`${(fundRaisedPercentage > 100 ? 100 : fundRaisedPercentage)}% raised`}
                        maxValueText={`${page.symbol_left}${currencyNeedsSpace(page.symbol_left) ? " " : ""}${(donationConstants.AMOUNT_FORMAT.includes(page.currency_code) ? page.fundraising_goal_human_readable.toLocaleString('de-DE') : page.fundraising_goal_human_readable.toLocaleString())}`}
                    />
                    <div className="donorinfo">
                        <div className="left">
                            <Avatar variant="square" src={S3_BUCKET + page.profile_image} className="img-fluid" fullName={page.first_name + " " + page.last_name} />
                        </div>
                        <div className="right">
                            <Span className="donor-name">
                                <a title={page.first_name + ' ' + page.last_name} href="#" onClick={e => e.preventDefault()} >{page.first_name + ' ' + page.last_name}</a>
                            </Span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}